import React from "react";
import { Box, Typography, type BoxProps } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { useAppContext } from "../context/AppContext";


const footerSx: BoxProps["sx"] = {
  flexShrink: 0,
  width: "100%",
  px: { xs: 2, md: 3 },
  py: 1.5,
  borderTop: "1px solid #e0e0e0",
  backgroundColor: "var(--color-background)",
};

type AppFooterProps = Pick<BoxProps, "sx">;

const AppFooter: React.FC<AppFooterProps> = ({ sx }) => {
  const { getTranslation } = useAppContext();

  return (
    <Box
      component="footer"
      sx={(sx ? [footerSx, sx] : footerSx) as SxProps<Theme>}
    >
      <Typography
        component="p"
        variant="body2"
        sx={{
          color: "var(--color-text-primary)",
          fontSize: { xs: "0.65rem", sm: "0.7rem" },
          lineHeight: 1.4,
          textAlign: "center",
          m: 0,
        }}
      >
        {getTranslation("Txt1016", "Esta herramienta es solo para orientación cosmética y no sustituye una evaluación médica profesional. No diagnostica ni trata condiciones de salud. Los resultados (incluidas imágenes con análisis por IA sin retoque) pueden variar según factores individuales y condiciones de captura. Ante cualquier duda, consulte con un profesional de la salud.")}
      </Typography>
    </Box>
  );
};

export default AppFooter;
